import React from 'react'

export default class ProgressBar extends React.Component{
 static defaultProps = {
   width:0,
   style:{},
   color:''
 }
 state = {
   width:0,
   isFirstLoad:true
 }
 componentDidMount(){
   //console.log("did mount", this.props.width)
   this.timeout = setTimeout(() => {
     this.setState({
       width: this.props.width,
       isFirstLoad:false
     })
   }, 200)
 }

 componentWillUnmount(){
   window.clearTimeout(this.timeout)
 }

 componentWillReceiveProps(nextProps){
   if(!this.state.isFirstLoad || this.state.width !== 0){
      return this.setState({
        width: nextProps.width
      })
   }else{
      return this.setState({
       width: 0
      })
   }
 }

 render () {
   let { style, color } = this.props;
   let width = this.state.width;
   return (
      <div className="progress" style={style}>
           <div className="progress-bar" role="progressbar" style={{width: width + '%', background: color}} aria-valuenow={ width + '%'} aria-valuemin="0" aria-valuemax="100"></div>
       </div>
   )
 }
}


// WEBPACK FOOTER //
// ./src/components/ProgressBar.js